import { TracingService } from "@gtmhub/core/tracing";
import { getToken } from "@gtmhub/auth";
import { storage } from "@gtmhub/core/storage";
import { v4 as uuidv4 } from "uuid";

export class WebWorkerService {
  public static $inject = ["TracingService"];

  constructor(private tracingService: TracingService) {}

  public createHttpHeaders(additionalParamsMap: { [key: string]: string }): Record<string, string> {
    const screen = this.tracingService.getScreen();
    const stateName = screen ? screen.screenName : "<unknown>";
    const map = {
      ...additionalParamsMap,
      "gtmhub-application-name": "webapp",
      "gtmhub-path": stateName,
    };

    const params = [];
    Object.keys(map).forEach((key) => {
      const value = map[key];
      const param = [key, value].join("=");
      params.push(param);
    });

    const headers = {
      Authorization: `Bearer ${getToken()}`,
      "gtmhub-accountId": storage.get<string>("accountId"),
      "gtmhub-additional-params": params.join(","),
    };
    headers["transaction-id"] = uuidv4();
    this.tracingService.setTracingHeaders(headers);

    return headers;
  }
}
